/**
 * Provider Details Page
 * Displays detailed provider information with ratings
 */

import { useParams, useSearchParams } from 'react-router-dom';
import ProviderDetails from '../components/ProviderDetails';

export default function ProviderDetailsPage() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const isDeletedView = searchParams.get('view') === 'deleted';

  return (
    <div className="bg-white-50 dark:bg-gray-900">
      {/* Provider Details Component */}
      {id ? (
        <ProviderDetails providerId={id} isDeletedView={isDeletedView} />
      ) : (
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 dark:bg-red-900/20 dark:border-red-800">
          <p className="text-red-700 dark:text-red-400">Provider ID is required</p>
        </div>
      )}
    </div>
  );
}
